import { FuelPricesMode, StoreLocationsQuery, StoreFragment } from '@ocx/graphql';
import { Coordinates, IStore, PriceType } from './types';
import { calculateDistance } from '../../lib/geolocation/utils/calculateDistance';
import { getDirectionLink } from '../../lib/geolocation/utils/getDirectionLink';
import { buildAddressLine2 } from '../../lib/store/addressLine';
import { FuelGradesConfiguration } from '../configuration/app-config.types';
import { mapFuelGradeGroups } from './mapFuelGrades';
import { mergeDuplicates } from './utils';

export const getLocationNodes = (storesData?: StoreLocationsQuery): StoreFragment[] => {
  if (!storesData?.stores?.edges?.length) {
    return [];
  }
  return storesData.stores.edges.map((edge) => edge.node).filter((node) => node?.address?.geoLocation);
};

export const mapLocationsData = (
  nodes: StoreFragment[],
  targetLocation: Coordinates,
  currentLocation: Coordinates,
  formatPrice: (price: number) => string,
  config: FuelGradesConfiguration,
  fuelPricesMode: FuelPricesMode,
  priceTypeTitles: Record<PriceType, string>,
): IStore[] => {
  // TODO just use "nodes" when fix is no more needed. See "mergeDuplicates" function for details
  const dedupedNodes = mergeDuplicates(nodes);
  const list: IStore[] = [];
  dedupedNodes.forEach((node) => {
    if (!node.address?.geoLocation) {
      return;
    }
    const { latitude: lat, longitude: lng } = node.address.geoLocation;

    const priceGroups = mapFuelGradeGroups({
      grades: node.fuelGradePrices,
      config,
      formatPrice,
      fuelPricesMode,
      priceTypeTitles,
    });

    const distance = calculateDistance(currentLocation, { lat, lng });
    const searchDistance = calculateDistance(targetLocation, { lat, lng });

    const { street1, city, state } = node.address;
    list.push({
      id: node.uuid,
      distance,
      searchDistance,
      directionLink: getDirectionLink(currentLocation, { lat, lng }),
      price: priceGroups[0]?.prices.find((price) => price.isDefault)?.price || null,
      fuelPriceState: node.fuelPriceState,
      priceGroups,
      addressLine1: street1,
      addressLine2: buildAddressLine2({ city, state }),
      lat,
      lng,
      location: node,
    });
  });

  return list;
};
